import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { SectionTitle } from "@/components/common";
import { toast } from "sonner";
import { Building2, User, Rocket, CheckCircle2, ChevronRight } from "lucide-react";

export default function ProntiPubblicazione() {
  const nav = useNavigate();
  const { isSegreteria } = useAuth();
  const [items, setItems] = useState(null);
  const [busy, setBusy] = useState(null);

  const load = () => api.get("/dashboard/pronti-pubblicazione").then((r) => setItems(r.data)).catch((e) => { toast.error(apiError(e)); setItems([]); });
  useEffect(() => { load(); }, []);

  const pubblica = async (e, im) => {
    e.stopPropagation();
    if (!window.confirm(`Confermi di aver pubblicato "${im.titolo || im.indirizzo}" sui portali? L'immobile passerà tra gli Immobili attivi.`)) return;
    setBusy(im.id);
    try { await api.post(`/immobili/${im.id}/pubblica`); toast.success("Immobile pubblicato e spostato tra gli attivi."); load(); }
    catch (err) { toast.error(apiError(err)); }
    finally { setBusy(null); }
  };

  if (!items) return <div className="skeleton h-96 rounded-2xl" />;

  return (
    <div className="fade-up" data-testid="pronti-pubblicazione-page">
      <SectionTitle sub="Immobili con documentazione completa, pronti per la pubblicazione sui portali.">Pronti per la pubblicazione</SectionTitle>
      {items.length === 0 ? (
        <div className="card-immo p-12 text-center text-sm text-[var(--muted)] mt-5" data-testid="pronti-empty">Nessun immobile pronto per la pubblicazione.</div>
      ) : (
        <div className="space-y-3 mt-5" data-testid="pronti-list">
          {items.map((im) => (
            <div key={im.id} data-testid={`pronti-row-${im.id}`} onClick={() => nav(`/immobili/${im.id}`)}
                 className="card-immo p-4 flex items-center gap-3 cursor-pointer hover:-translate-y-0.5 transition-transform">
              <div className="w-9 h-9 rounded-lg bg-emerald-400/10 text-emerald-600 flex items-center justify-center shrink-0"><Rocket size={17} /></div>
              <div className="flex-1 min-w-0">
                <div className="font-semibold text-sm truncate flex items-center gap-2"><Building2 size={13} className="text-[#FC82ED]" /> {im.titolo || im.indirizzo || "Immobile"}</div>
                <div className="text-[11px] text-[var(--muted)] flex flex-wrap items-center gap-x-3 gap-y-1 mt-1">
                  <span className="flex items-center gap-1"><User size={11} />{im.agente || "—"}</span>
                  {im.proprietario && <span>Venditore: {im.proprietario}</span>}
                  <span className="inline-flex items-center px-1.5 py-0.5 rounded-full border text-emerald-600 bg-emerald-400/10 border-emerald-400/30 text-[10px] font-bold">Documenti completi {im.doc_verificati || 0}/{im.doc_totali || 0}</span>
                </div>
              </div>
              {isSegreteria && (
                <button data-testid={`pubblica-${im.id}`} disabled={busy === im.id} onClick={(e) => pubblica(e, im)}
                        className="shrink-0 flex items-center gap-1.5 px-3 py-2 rounded-lg bg-emerald-500 hover:bg-emerald-600 text-white text-xs font-semibold disabled:opacity-60">
                  <CheckCircle2 size={13} /> Pubblicato
                </button>
              )}
              <ChevronRight size={16} className="text-[var(--muted)] shrink-0" />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
